module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f0cf.080ef5f5.svg";